import {
  CheckoutChannels,
  CheckoutExperience,
  CheckoutExperiences,
  Program,
} from '@ads-bread/shared/bread/codecs';

/**
 * Determines if the given checkout experience is an in-store experience.
 * @param experience
 * @returns boolean
 */
export const isInStoreExperience = (
  experience: CheckoutExperiences
): boolean => {
  switch (experience) {
    case CheckoutExperience.Clover:
    case CheckoutExperience.VirtualCard:
    case CheckoutExperience.VirtualCardEcomm:
      return true;
    default:
      return false;
  }
};

/**
 * Get the CheckoutExperience from a given Program.
 * @param program Program
 * @returns CheckoutExperience
 */
export const getCheckoutExperienceFromProgram = (
  program: Program
): CheckoutExperience => {
  switch (program.checkoutChannel) {
    case CheckoutChannels.InStorePlatform:
    case CheckoutChannels.InStoreUnifiedPrequalVirtualCard:
    case CheckoutChannels.InhomeVirtualCard:
    case CheckoutChannels.Inhome:
    case CheckoutChannels.InstoreVirtualCard:
      return CheckoutExperience.VirtualCard;
    case CheckoutChannels.EcommerceVirtualCard:
      return CheckoutExperience.VirtualCardEcomm;
    case CheckoutChannels.InstorePOS:
      return CheckoutExperience.Clover;
    case CheckoutChannels.Ecomm:
    case CheckoutChannels.EcommEnhancedPreQual:
      return CheckoutExperience.Ecomm;
    default:
      return CheckoutExperience.Ecomm;
  }
};
